import axios from 'axios'

const GOOGLE_TRANSLATE_API = 'https://translation.googleapis.com/language/v3:translateText'
const API_KEY = process.env.REACT_APP_GOOGLE_TRANSLATE_API_KEY || ''

export const googleTranslate = async (text: string, targetLang: string, sourceLang = 'en'): Promise<string> => {
    try {
        if (!API_KEY) return text

        const response = await axios.post(
            GOOGLE_TRANSLATE_API,
            {
                contents: [text],
                targetLanguageCode: targetLang,
                sourceLanguageCode: sourceLang,
                mimeType: 'text/plain',
            },
            {
                params: { key: API_KEY },
                headers: { 'Content-Type': 'application/json' },
            },
        )

        return response.data?.translations?.[0]?.translatedText ?? text
    } catch {
        return text
    }
}
